<template>
  <div :class="['flex items-center', noBorder ? '' : 'border-b border-gray-200']">
    <component
      :is="tab.to ? 'router-link' : 'button'"
      v-for="tab in normalizedTabs"
      :key="tab.id || tab.label"
      v-tooltip="tab.description"
      :to="tab.to || undefined"
      :type="tab.to ? undefined : 'button'"
      :aria-label="tab.description ? `${tab.label}: ${tab.description}` : undefined"
      style="font-size: 13px;"
      :class="[
        'px-3 py-2.5 font-medium border-b-2 -mb-px transition-colors no-underline cursor-pointer bg-transparent',
        isActive(tab)
          ? 'border-gray-900 text-gray-900'
          : 'border-transparent text-gray-500 hover:text-gray-700'
      ]"
      @click="switchTab(tab)"
    >
      <font-awesome-icon v-if="tab.icon" :icon="tab.icon" class="mr-1 text-xs" />
      {{ tab.label }}
      <span v-if="tab.badge" class="ml-1.5 rounded-full bg-primary-50 px-2 text-gray-900">{{ tab.badge }}</span>
    </component>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import tooltip from '@/directives/tooltip';

export default {
  name: 'PageTabs',
  components: {
    FontAwesomeIcon,
  },
  directives: { tooltip },
  props: {
    initialTab: {
      type: String,
      default: ''
    },
    // Each item: string | { label, id?, icon?, description?, to?, badge? }
    // When `to` is provided, the tab renders as a router-link
    // When `id` is provided, it is used for matching and emitting instead of label
    // `description` is exposed as an immediate hover/focus tooltip.
    tabs: {
      type: Array,
      required: true
    },
    noBorder: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select'],
  computed: {
    currentTab() {
      return this.initialTab;
    },
    normalizedTabs() {
      return this.tabs.map(tab =>
        typeof tab === 'string' ? { label: tab } : tab
      );
    },
  },
  methods: {
    isActive(tab) {
      if (tab.to) {
        return this.$route.path === tab.to || this.$route.path.startsWith(tab.to + '/');
      }
      return this.currentTab === (tab.id || tab.label);
    },
    switchTab(tab) {
      this.$emit('select', tab.id || tab.label);
    },
  }
}
</script>

<style scoped>
a.no-underline {
  text-decoration: none;
  color: inherit;
}

a.no-underline:hover {
  color: inherit;
}

</style>
